// extracted by mini-css-extract-plugin
export default {"modal":"CreateProjectModal_modal__RJXfI","content":"CreateProjectModal_content__PfbzD"};